import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import T from 'aegisv2/Text';
import styled from 'styled-components';
import { func, arrayOf, number, shape, bool, string } from 'prop-types';
import { CATALOG_TRANSLATION_KEY } from 'Jsx/Utils/transformKeys';
import { ContainerDesktop } from 'Jsx/Catalog/ui/Responsive';
import { setCurrentPage } from 'Catalog/Pagination/ducks';
import { secondaryMain } from 'crehana-ui/styles/colors';
import Filter from './components/Filter';
// import ShowOfferBtn from './components/ShowOfferBtn';
import { FILTER_TYPES } from './redux/reducer';

import {
  openFilterCategory,
  toggleFilterCategory,
  toggleFilterSoftware,
  // toggleFilterCourses,
  openFilterSoftware,
  openFilterLevel,
  toggleFilterLevel,
  //
  clearAllFilters,
  toggleFilterDialog,
  showAllCourses,
} from './redux/actions';

import {
  getSoftwaresSelectedIds,
  getLevelsSelectedIds,
} from './redux/selectors';

import { clearSearch } from '../SearchLanding/redux/actions';

import { setDefaultOrderBy } from '../OrderByV2/redux/actions';

const Container = styled.div`
  position: relative;
`;

const WithMarginBottom = styled.h3`
  margin-bottom: 14px;
`;

const FiltersWrapper = styled.div`
  ${'' /* & > div:not(:last-child) {
    margin-bottom: 8px;
  } */}
  & > div {
    &:first-child {
      border-top-right-radius: 5px;
      border-top-left-radius: 5px;
    }
    &:last-child {
      border-bottom-right-radius: 5px;
      border-bottom-left-radius: 5px;
    }
  }
`;

class FiltersV2 extends Component {
  state = {
    isClient: false,
  };

  componentDidMount() {
    const elements = document.querySelectorAll('.sticky');

    const Stickyfill = require('stickyfilljs'); // eslint-disable-line global-require

    Stickyfill.add(elements);

    if (window.innerWidth <= 1024) {
      this.setState({ isClient: true }); // eslint-disable-line
    } else {
      this.setState({ isClient: true }); // eslint-disable-line
    }
  }

  toggleCategory = ({ itemId, subItemId }) => {
    this.props.toggleFilterCategory({ itemId, subItemId });
  };

  resetPaginationBefore = functionToRun => (...params) => {
    this.props.setCurrentPage(1);
    functionToRun(...params);
  };

  scrollTopBefore = functionToRun => (...params) => {
    const { scrollTop } = this.props;

    scrollTop();
    functionToRun(...params);
  };

  clearSearchBefore = functionToRun => (...params) => {
    const { search, clearSearch: clearSearchAction } = this.props;

    if (search) {
      clearSearchAction();
      if (window.clearTextValue) window.clearTextValue();
    }
    functionToRun(...params);
  };

  clearFiltersMobile = () => {
    const {
      setDefaultOrderBy: setDefaultOrderByAction,
      orderBySelected,
      defaultOrderBy,
    } = this.props;

    if (orderBySelected.slug !== defaultOrderBy.slug) {
      setDefaultOrderByAction();
    }

    this.props.clearAllFilters();
    this.props.toggleFilterDialog();
  };

  showAllCourses = e => {
    e.preventDefault();
    const {
      allCourses,
      scrollTop,
      showAllCourses: showAllCoursesActions,
      setDefaultOrderBy: setDefaultOrderByAction,
      clearAllFilters: clearAllFiltersAction,
      orderBySelected,
      defaultOrderBy,
    } = this.props;

    scrollTop();

    clearAllFiltersAction();

    if (orderBySelected.slug !== defaultOrderBy.slug) {
      setDefaultOrderByAction();
    }

    if (!allCourses) {
      showAllCoursesActions();
    }
  };

  toggleOfferCourses = e => {
    e.preventDefault();
  };

  toggleSubItem = (itemId, subItemId, filterName) => e => {
    const { toggleFilterDialog: toggleFilterDialogAction } = this.props;

    if (e.stopPropagation) e.stopPropagation();
    switch (filterName) {
      case 'Software':
        this.scrollTopBefore(
          this.props.toggleFilterSoftware({ itemId, subItemId }),
        );
        break;
      case 'Niveles':
        this.scrollTopBefore(
          this.props.toggleFilterLevel({ itemId, subItemId }),
        );
        break;
      default:
        this.resetPaginationBefore(
          this.clearSearchBefore(
            this.scrollTopBefore(
              this.props.toggleFilterCategory({ itemId, subItemId }),
            ),
          ),
        );
        toggleFilterDialogAction();
        break;
    }
  };

  render() {
    const { isClient } = this.state;
    const {
      categories,
      softwares,
      levels,
      categorySelected,
      categoryOpen,
      softwaresSelectedIds,
      levelsSelectedIds,
      countryPrefix,
      t,
    } = this.props;

    return (
      <Container>
        <ContainerDesktop>
          <WithMarginBottom>
            <a
              href="/cursos-online/?all=true"
              onClick={this.clearSearchBefore(this.showAllCourses)}
            >
              <T xs bold size={12} lineHeight={16} color={secondaryMain}>
                {t('SHOW_ALL_COURSES')}
              </T>
            </a>
          </WithMarginBottom>
          <WithMarginBottom>
            <T size={12} bold>
              Categorías
            </T>
          </WithMarginBottom>
          <FiltersWrapper>
            {Object.keys(categories).map(key => (
              <Filter
                key={categories[key].id}
                itemType={FILTER_TYPES.CATEGORIES}
                item={categories[key]}
                countryPrefix={countryPrefix}
                toggleSubItem={this.resetPaginationBefore(
                  this.clearSearchBefore(
                    this.scrollTopBefore(this.props.toggleFilterCategory),
                  ),
                )}
                openFilter={this.resetPaginationBefore(
                  this.scrollTopBefore(
                    this.clearSearchBefore(this.props.openFilterCategory),
                  ),
                )}
                subItemsSelected={[categorySelected]}
                open={isClient && categoryOpen.itemId === categories[key].id}
              />
            ))}
          </FiltersWrapper>
          <WithMarginBottom style={{ marginTop: 44 }}>
            <T size={12} bold>
              Filtros
            </T>
          </WithMarginBottom>
          <FiltersWrapper>
            <Filter
              itemType={FILTER_TYPES.SOFTWARES}
              item={softwares}
              toggleSubItem={this.scrollTopBefore(
                this.props.toggleFilterSoftware,
              )}
              openFilter={this.props.openFilterSoftware}
              subItemsSelected={softwaresSelectedIds}
              open={softwares.open}
            />
            <Filter
              itemType={FILTER_TYPES.LEVELS}
              item={levels}
              toggleSubItem={this.scrollTopBefore(this.props.toggleFilterLevel)}
              openFilter={this.props.openFilterLevel}
              subItemsSelected={levelsSelectedIds}
              open={levels.open}
            />
          </FiltersWrapper>
        </ContainerDesktop>
      </Container>
    );
  }
}

FiltersV2.defaultProps = {
  search: null,
};

FiltersV2.propTypes = {
  scrollTop: func.isRequired,
  // redux-data
  softwaresSelectedIds: arrayOf(number).isRequired,
  levelsSelectedIds: arrayOf(number).isRequired,
  openDialog: bool.isRequired,
  // redux-actions
  openFilterCategory: func.isRequired,
  toggleFilterCategory: func.isRequired,

  toggleFilterSoftware: func.isRequired,
  openFilterSoftware: func.isRequired,

  openFilterLevel: func.isRequired,
  toggleFilterLevel: func.isRequired,

  toggleFilterDialog: func.isRequired,
  clearAllFilters: func.isRequired,

  setDefaultOrderBy: func.isRequired,
  setCurrentPage: func.isRequired,

  // fakeid
  categoryOpen: shape({ itemId: string }).isRequired,
  categorySelected: shape({
    // fakeid
    itemId: string,
    subItemId: number,
  }).isRequired,

  showAllCourses: func.isRequired,
  search: string,
  clearSearch: func.isRequired,
  allCourses: bool.isRequired,
  defaultOrderBy: shape({}).isRequired,
  orderBySelected: shape({}).isRequired,

  isPremiumMember: bool.isRequired,
};

const mapStateToProps = state => ({
  ...state.filters,
  softwaresSelectedIds: getSoftwaresSelectedIds(state),
  levelsSelectedIds: getLevelsSelectedIds(state),
  search: state.search.value,
  defaultOrderBy: state.orderBy.defaultOrderBy,
  orderBySelected: state.orderBy.itemSelected,
});

const mapActionsToProps = {
  toggleFilterCategory,
  openFilterCategory,

  openFilterSoftware,
  toggleFilterSoftware,

  openFilterLevel,
  toggleFilterLevel,

  toggleFilterDialog,
  clearAllFilters,

  clearSearch,
  showAllCourses,

  setDefaultOrderBy,
  setCurrentPage,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(withTranslation(CATALOG_TRANSLATION_KEY)(FiltersV2));
